import { CheckIcon } from '@change/ds-icons';

import { Text, ThemeProvider } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';
import { createModalHook } from '@change-corgi/design-system-legacy/modals';

export const useReportAbuseConfirmModal = createModalHook({
	name: 'ReportAbuseConfirmModal',
	title: () => (
		<ThemeProvider>
			<Translate value="fe.components.petition_report_abuse.form_title" />
		</ThemeProvider>
	),
	body: function ReportAbuseConfirmModalBody() {
		return (
			<ThemeProvider>
				<CheckIcon size="x-small" className="mr-2 translate-y-0.5" />
				<Text>
					<Translate value="fe.components.petition_report_abuse.form_confirmation" />
				</Text>
			</ThemeProvider>
		);
	},
});
